export enum CommunityMultiplierType {
    Ovols = 0,
    OvalsTop100 = 1,
    OvalsTop25 = 2,
    BanxWhale = 3,
    BanxDolphin = 4,
    BanxCod = 5,
    BanxShrimp = 6,
    SkrGenesis = 7
}

export interface CommunityMultiplierReturn {
    communityMultiplier: number;
    multiplier: number;
}
